import { LawyerCard } from "./lawyer-card";
import PropTypes from 'prop-types';
const BestLawyers = ({ lawyers }) => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {lawyers?.map((lawyer, index) => (
          <LawyerCard key={index} index={1} {...lawyer} />
        ))}
      </div>
    </div>
  );
};
BestLawyers.propTypes = {
  lawyers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BestLawyers;


